export default {
  'validators.tinNumberFormat':
    '请输入正确的TIN号码格式（如 123-456-789-001 或 123-456-789-12345）',
  'validators.phoneNumberFormat': '请输入正确的菲律宾手机号码格式',
  // 2026-09-28 表单规则文案纳入内置 locales(此前 formRules.ts 硬编码中文)
  'validators.emailFormat': '请输入正确的邮箱地址',
  'validators.englishOnly': '只能输入英文字母',
  'validators.numberOnly': '只能输入数字',
  'validators.alphanumeric': '只能输入英文和数字',
  'validators.alphanumericDash': '只能输入英文、数字和中划线',
  'validators.passwordPattern':
    '密码须为 6-20 位，同时包含字母和数字，且不能包含中文',
};
